import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Brain } from "lucide-react";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/instructions", { state: { user: res.data } });
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B0F17] gap-4">
      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500 to-indigo-500 flex items-center justify-center animate-pulse">
        <Brain className="w-7 h-7 text-white" />
      </div>
      <p className="text-slate-400 font-mono-data text-sm">Establishing secure session…</p>
    </div>
  );
};
